import React from 'react';
import './price.css';

const Price = props => <div className='price'>
  {props.price >= 1 ? (<span>$</span>) : (<span className='gray-out'>$</span>)}
  {props.price >= 2 ? (<span>$</span>) : (<span className='gray-out'>$</span>)}
  {props.price >= 3 ? (<span>$</span>) : (<span className='gray-out'>$</span>)}
  {props.price >= 4 ? (<span>$</span>) : (<span className='gray-out'>$</span>)}
</div>;

export default Price;



// WEBPACK FOOTER //
// ./src/components/price/Price.js